import React from 'react'
import { Avatar, Text, Heading, Tag } from '@lmc/ui-kit'
import styled from 'styled-components'
import { ResidentItem } from '@lmc/ts-common'
import { getResidentStatus } from '../utils'
import useHomeType from 'hooks/useHomeType'

type ResidentListHeaderProps = {
  resident: ResidentItem
  onClick: React.MouseEventHandler<HTMLDivElement>
  firstItem?: boolean
}

const ResidentListItem = ({
  resident,
  onClick,
  firstItem,
}: ResidentListHeaderProps) => {
  const { isDoLSOverride } = useHomeType()

  const picture = resident?.picture as unknown as string
  const name = `${resident?.name?.first} ${resident?.name?.last}`
  const hasAllergies = resident.residentAllergies?.length > 0
  const hasDnacpr = resident.dnacpr
  const hasBadges = resident.dols || hasAllergies || hasDnacpr

  return (
    <StyledPaddingWrapper>
      <StyledContainer onClick={onClick} $firstItem={firstItem}>
        <Avatar url={picture} size={40} />
        <StyledHeading level={5}>{name}</StyledHeading>
        <StyledRowWrapper>
          {hasBadges && (
            <StyledBadges>
              {resident.dols && (
                <Tag color="blue">{isDoLSOverride ? 'DoLS' : 'LPS'}</Tag>
              )}
              {hasAllergies && <Tag color="green">Allergies</Tag>}
            </StyledBadges>
          )}
          <StyledWrapper>
            <StyledText level={5}>{getResidentStatus(resident)}</StyledText>
          </StyledWrapper>
        </StyledRowWrapper>
      </StyledContainer>
    </StyledPaddingWrapper>
  )
}

const StyledContainer = styled.div<{ $firstItem?: boolean }>`
  background-color: ${(props) => props.theme.palette.white} !important;
  border-radius: 8px;
  margin-bottom: 10px;
  margin-top: ${(props) => (props?.$firstItem ? '24px' : '0px')};
  height: 64px;
  display: flex;
  align-items: center;
  padding: 16px 12px;
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  cursor: pointer;
  &:hover {
    background-color: ${(props) =>
      props.theme.color.neutral.color10} !important;
  }
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin-top: 0px;
  }
`

const StyledWrapper = styled.div`
  display: flex;
  margin-right: 0px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    display: none;
  }
`

const StyledBadges = styled.div`
  display: flex;
  margin-left: auto;
  padding-right: 10px;
  border-right: 1px solid #ded5e6;
  height: fit-content;
  min-width: 100px;
  justify-content: flex-end;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    display: none;
  }
`

const StyledHeading = styled(Heading)`
  margin-left: 10px;
`

const StyledRowWrapper = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
`

const StyledText = styled(Text)`
  font-size: 12px !important;
  min-width: 100px;
  text-align: center;
`

const StyledPaddingWrapper = styled.div`
  padding-left: 24px;
  padding-right: 24px;
`

export default ResidentListItem
